import React, { useState } from "react";
import { Redirect, useHistory } from "react-router-dom";
import NoSidebarLayout from "../../components/Layout/NoSidebarLayout";

import { useStore } from "../../store/useStore";
import Title from "antd/lib/typography/Title";
import { Cache } from "aws-amplify";
import { Form, Input, Button, notification } from "antd";
import { confirmAccount, resendCode } from "../../store/actions";
import Paragraph from "antd/lib/typography/Paragraph";

type FormData = {
  code: string;
};

type HistoryState = {
  message?: string;
};

const ConfirmCodePage: React.FC = () => {
  const { state, dispatch } = useStore();
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory<HistoryState>();
  if (state.user) return <Redirect to="/" />;
  const email: string = Cache.getItem("toVerifyEmail");
  if (!email) return <Redirect to="/login" />;
  const message = history.location.state?.message;

  /**
   * I hate this
   */
  const hideEmail = (email: string) => {
    const generateAsteriks = (number: number) => {
      let str: string = "";
      for (let i = 0; i < number; i++) {
        str = str + "*";
      }
      return str;
    };

    const split: string[] = email.split("@");
    const domain: string[] = split[1].split(".");
    let part1: string =
      split[0].substr(0, 1) +
      generateAsteriks(split[0].length - 2) +
      split[0].substr(split[0].length - 1, split[0].length);
    let part2: string =
      domain[0].substr(0, 1) +
      generateAsteriks(domain[0].length - 2) +
      domain[0].substr(domain[0].length - 1, domain[0].length) +
      "." +
      domain[1];
    domain.shift();
    domain.shift(); // Lol
    const remainder = domain.join(".");
    return [part1, (part2 += remainder)].join("@");
  };

  const handleSubmit = async (values: FormData) => {
    setLoading(true);
    try {
      await dispatch(confirmAccount(email, values.code));
      Cache.removeItem("toVerifyEmail");
      notification.success({
        message: "Account verified. You can now sign in",
        placement: "bottomRight",
      });
      history.push({ pathname: "/login", state: {} });
    } catch (error) {
      notification.error({
        message: "Incorrect verification code, please try again",
        placement: "bottomRight",
      });
    }
    setLoading(false);
  };

  const handleResendCode = async () => {
    try {
      await dispatch(resendCode(email));
      notification.success({
        message: "Code resent, please check your email",
        placement: "bottomRight",
      });
    } catch (error) {
      notification.error({
        message: "Unable to resend code, please try again",
        placement: "bottomRight",
      });
    }
  };

  const SentTo = () => {
    return (
      <Paragraph>
        A confirmation code has been sent to {hideEmail(email)}
      </Paragraph>
    );
  };

  const WithMessage = () => {
    return (
      <div className="flex flex-col text-center">
        <Title className="text-center" level={4}>
          {message}
        </Title>
        <SentTo />
      </div>
    );
  };

  return (
    <NoSidebarLayout>
      <div className="flex h-full items-center">
        <Form
          name="normal_login"
          className="flex flex-col w-full"
          initialValues={{}}
          onFinish={(values) => {
            handleSubmit(values as FormData);
          }}
        >
          <WithMessage />
          <Form.Item
            name="code"
            rules={[
              { required: true, message: "Required" },
              { min: 6, max: 6, message: "Code must be 6 digits" },
            ]}
          >
            <Input
              className="text-center"
              autoComplete="new-password"
              placeholder="6 digit code"
              disabled={loading}
            />
          </Form.Item>

          <Form.Item className="flex flex-col">
            <div className="flex flex-col text-center">
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={loading}
              >
                Confirm account
              </Button>
            </div>
            <Form.Item className="flex flex-col">
              <div className="flex flex-col text-center mt-2">
                <Button
                  type="primary"
                  danger
                  onClick={handleResendCode}
                  disabled={loading}
                >
                  Resend code
                </Button>
              </div>
            </Form.Item>
          </Form.Item>
        </Form>
      </div>
    </NoSidebarLayout>
  );
};

export default ConfirmCodePage;
